import { createSelector } from "reselect";

const selectEntity = state => state.entities.video;
const selectEntityData = state =>
  state.entities.video ? Object.values(state.entities.video.data) : [];

export const makeSelectVideo = () =>
  createSelector([selectEntityData], substate => substate);

export const makeSelectVideoLoading = () =>
  createSelector(selectEntity, substate => {
    if (substate) return substate.isLoading;
    return false;
  });
